export default () => ({
  link: {
    display: 'flex',
    alignItems: 'center'
  },
  teamName: {
    paddingLeft: 8
  }
});
